import { render, staticRenderFns } from "./PartnerDataSummary.vue?vue&type=template&id=4d20aff4"
import script from "./PartnerDataSummary.vue?vue&type=script&lang=ts"
export * from "./PartnerDataSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports